<!-- Modal Activity Log -->
<ng-template #dialogActivityLog let-c="close" let-d="dismiss">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="d-flex justify-content-between p-3 pb-0">
      <div [style.background-image]="'url(' + logo + ')'" class="logo"></div>
      <div class="close-button" (click)="d('Cross click')">x</div>
    </div>
    <div class="modal-header">
      <h4 class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate>filials.filial.activityLog</h4>
    </div>
    <div class="modal-body">
      <div *ngIf="!activeLogList.length" translate><span translate>filials.filial.noActivityLog</span></div>
      <ng-container *ngFor="let log of activeLogList">
        <div class="row list_container mb-3">
          <div class="d-flex mb-2 align-items-center" translate>filials.filial.date
            <span>{{log.updatedAt | date:'yyyy-MM-dd HH:mm:ss'}}</span>
          </div>
          <div class="d-flex  mb-2 align-items-center">
            {{log.reason}}
          </div>
          <div class="d-flex mb-2 align-items-center" translate>filials.filial.userEmail
            <span>{{log.user.email}}</span>
          </div>
          <div class="d-flex mb-2 align-items-center" translate>filials.filial.role
            <div [ngSwitch]="log.user.role.name">
              <span *ngSwitchCase="'user'">Company admin</span>
              <span *ngSwitchCase="'filialAdmin'">Filial Admin</span>
              <span *ngSwitchCase="'root'">Root</span>
              <span *ngSwitchDefault>{{log.user.role.name}}</span>
            </div>
          </div>
          <div *ngIf="log.user.company" class="d-flex mb-2 align-items-center" translate>filials.filial.companyName
            <span> {{log.user.company.name}}</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>